import React from 'react';

import { Typography } from '@mui/material';

interface IWrapperStyles {
    color?: string;
    fontSize?: string;
    fontWeight?: string;
}

interface IFieldValueInlineStyles {
    [key: string]: string
}

interface IDeleteDialogCustomFieldProps {
    fieldName: string;
    fieldValue?: string;
    wrapperStyles?: IWrapperStyles;
    fieldValueInlineStyles?: IFieldValueInlineStyles;
}

const DEFAULT_WRAPPER_STYLES: IWrapperStyles = {
    color: 'info.light',
    fontSize: '0.9rem',
    fontWeight: '550'
};

const DEFAULT_FIELD_VALUE_INLINE_STYLES: IFieldValueInlineStyles = {
    color: 'text.primary',
    fontWeight: '400'
};

export const DeleteDialogCustomField: React.FC<IDeleteDialogCustomFieldProps> = ({
    fieldName,
    fieldValue,
    wrapperStyles = DEFAULT_WRAPPER_STYLES,
    fieldValueInlineStyles = DEFAULT_FIELD_VALUE_INLINE_STYLES
}) => {
    const { color, fontSize, fontWeight } = wrapperStyles;
    return (
        <Typography color={color} fontSize={fontSize} fontWeight={fontWeight}>
            {fieldName}: <Typography component="span" sx={fieldValueInlineStyles}>{fieldValue}</Typography>
        </Typography>
    );
};
